var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-back-wrapper"},[_c('BaseButton',{attrs:{"slot":"button","title":"Back"},nativeOn:{"click":function($event){return _vm.goBack($event)}},slot:"button"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-768cb0a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseButtonBack.vue
// module id = 822
// module chunks = 0